import axiosInstance from "../utils/axiosInstance";
import { URLS } from "api/utils/baseUrls";
import { MessagesDto } from "api/dtos/MessagesDto";
import { constructSearchParams } from "utils/constructSearchParams";

const getAllSms = async () => {
  try {
    const { data } = await axiosInstance.get(`${URLS.messaging}/campaigns/`);
    const smsData = MessagesDto.setupSms(data);
    return smsData;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getAllEmails = async () => {
  try {
    const { data } = await axiosInstance.get(`${URLS.messaging}/campaigns/`);
    const emailData = MessagesDto.setupEmails(data);
    return emailData;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getMessage = async (campaignId) => {
  try {
    const params = constructSearchParams({ campaignId });
    const { data } = await axiosInstance.get(`${URLS.messaging}/campaign/`, {
      params,
    });
    const messageData = MessagesDto.setupCampaign(data);
    return messageData;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getBalance = async () => {
  try {
    const { data } = await axiosInstance.get(`${URLS.messaging}/balance/`);
    const balance = MessagesDto.setupBalance(data);
    return balance;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getPlaceholders = async (userId) => {
  try {
    const params = constructSearchParams({ userId });
    const { data } = await axiosInstance.get(
      `${URLS.messaging}/placeholder_tags/`,
      { params }
    );
    const placeholdersData = MessagesDto.setupPlaceholders(data);
    return { data: placeholdersData };
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const sendMessageCampaign = async (payload) => {
  try {
    const finalPayload = MessagesDto.setupCreatedCampaign(payload);
    const { data } = await axiosInstance.post(
      `${URLS.messaging}/create_campaigns/`,
      finalPayload
    );
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const messagesApi = {
  sendMessageCampaign,
  fetchAllSms: getAllSms,
  fetchAllEmails: getAllEmails,
  fetchBalance: getBalance,
  fetchMessage: getMessage,
  fetchPlaceholders: getPlaceholders,
};
